export const SET_PDF_DIALOG_DATA = "SET_PDF_DIALOG_DATA";